import React from "react"
import { observer } from "mobx-react-lite"
import { ViewStyle } from "react-native"
import { StackScreenProps } from "@react-navigation/stack"

import { Layout, Account } from "@app/components"
import { color } from "@app/theme"
import { RootNavigatorParamList } from "@app/navigators/navigator-params"

type RegisterScreenProps = StackScreenProps<RootNavigatorParamList, "Register">
export const RegisterScreen = observer((props: RegisterScreenProps) => {
  const close = () => {
    props.navigation.navigate("Tabs", { screen: "Home", params: { screen: "Offers" } })
  }

  return (
    <Layout.ModalScreen style={CONTAINER} onClosePress={close} closeIconPreset="icon">
      <Account.Register style={ACCOUNT} />
    </Layout.ModalScreen>
  )
})

const CONTAINER: ViewStyle = {
  backgroundColor: color.background
}
const ACCOUNT: ViewStyle = {
  alignSelf: "center",
  maxWidth: 900
}
